import { ListLoader } from "@/loaders";

export default {
  listDefault: new ListLoader("/payment/default-order-lines/", {
    setter: "orderLine/setDefaultOrderLines",
  }),
  list: new ListLoader("/payment/order-lines/", { isSingleRequest: false }),
};
